import React, { CSSProperties } from 'react';
import { Button } from '../../../Button';

interface Props {
  children?: React.ReactNode;
  onClick: () => void;
  style?: CSSProperties;
}

export const CancelButton = ({
  children = 'Cancelar',
  onClick,
  style,
}: Props) => {
  return (
    <Button handleClick={onClick} variant="cancel" style={style}>
      {children}
    </Button>
  );
};
